import type { ReactElement } from "react";

export interface BrandMarkProps {
  /** Edge length in `rem`-relative units; defaults to the header size. */
  size?: string;
}

/**
 * The product mark: the same rounded-square shape the public site uses, in the
 * operator colourway with a stacked-rows glyph. Purely decorative — the
 * adjacent wordmark carries the accessible name, so this is hidden from
 * assistive technology rather than announced twice.
 */
export function BrandMark({ size = "1.75rem" }: BrandMarkProps): ReactElement {
  return (
    <svg
      viewBox="0 0 32 32"
      fill="none"
      width={size}
      height={size}
      aria-hidden="true"
      focusable="false"
    >
      <rect width="32" height="32" rx="8" fill="var(--ink-900)" />
      <rect x="8" y="9" width="16" height="3" rx="1.5" fill="var(--teal-300)" />
      <rect x="8" y="14.5" width="16" height="3" rx="1.5" fill="var(--teal-300)" opacity="0.7" />
      <rect x="8" y="20" width="10" height="3" rx="1.5" fill="var(--teal-300)" opacity="0.45" />
    </svg>
  );
}
